module.exports = __webpack_public_path__ + "static/Aeonik-Bold-f15af3ba7d20fd7c15683f7d485bc731.ttf";